
export default function StudentCouncilSection() {
  const councilMembers = [
    {
      name: 'Sarah Chen',
      position: 'President',
      school: 'University of Toronto - Pharmacy',
      year: '4th Year',
      image: 'https://public.readdy.ai/ai/img_res/cc484e8b632dc39f65f7b5d9538794c3.jpg'
    },
    {
      name: 'Marcus Johnson',
      position: 'Vice President',
      school: 'Western University - Veterinary Medicine',
      year: '3rd Year',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Black%20man%20veterinary%20student%2C%20friendly%20professional%20expression%2C%20wearing%20medical%20scrubs%2C%20clean%20hospital%20background%2C%20academic%20portrait%2C%20natural%20lighting&width=300&height=300&seq=council2&orientation=squarish'
    },
    {
      name: 'Emily Rodriguez',
      position: 'Secretary',
      school: 'University of British Columbia - Pharmacy',
      year: '3rd Year',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Hispanic%20woman%20pharmacy%20student%2C%20warm%20professional%20smile%2C%20wearing%20business%20attire%2C%20modern%20office%20background%2C%20academic%20portrait%2C%20natural%20lighting&width=300&height=300&seq=council3&orientation=squarish'
    },
    {
      name: 'David Kim',
      position: 'Treasurer',
      school: 'University of Guelph - Veterinary Medicine',
      year: '4th Year',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20veterinary%20student%2C%20confident%20professional%20appearance%2C%20wearing%20dress%20shirt%2C%20clean%20medical%20facility%20background%2C%20academic%20portrait%2C%20bright%20lighting&width=300&height=300&seq=council4&orientation=squarish'
    },
    {
      name: 'Rachel Thompson',
      position: 'Communications Director',
      school: 'Dalhousie University - Pharmacy',
      year: '2nd Year',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Caucasian%20woman%20pharmacy%20student%2C%20professional%20friendly%20smile%2C%20wearing%20white%20coat%2C%20university%20laboratory%20background%2C%20academic%20portrait%2C%20natural%20lighting&width=300&height=300&seq=council5&orientation=squarish'
    },
    {
      name: 'Ahmed Hassan',
      position: 'Events Coordinator',
      school: 'University of Calgary - Veterinary Medicine',
      year: '2nd Year',
      image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Middle%20Eastern%20man%20veterinary%20student%2C%20professional%20appearance%2C%20wearing%20medical%20scrubs%2C%20clean%20clinic%20background%2C%20academic%20portrait%2C%20bright%20lighting&width=300&height=300&seq=council6&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Meet the Student Council
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our elected student representatives work tirelessly to advocate for student interests and organize programs that benefit the entire CPVA student community
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {councilMembers.map((member, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
              <img
                src={member.image}
                alt={member.name}
                className="w-24 h-24 rounded-full mx-auto mb-4 object-cover object-top"
              />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {member.name}
              </h3>
              <div className="text-blue-600 font-medium mb-1">
                {member.position}
              </div>
              <div className="text-gray-600 text-sm mb-1">
                {member.school}
              </div>
              <div className="text-gray-500 text-sm">
                {member.year}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-50 rounded-lg p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Interested in Running for Council?
              </h3>
              <p className="text-gray-600 mb-6">
                Student Council elections are held annually in February. Representatives serve one-year terms and gain valuable leadership experience while making a difference in the student community.
              </p>
              <div className="space-y-2 text-sm text-gray-700">
                <div className="flex items-center">
                  <i className="ri-calendar-line text-blue-500 mr-2"></i>
                  <span>Elections: February 2024</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line text-green-500 mr-2"></i>
                  <span>Term: March 2024 - February 2025</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-user-line text-purple-500 mr-2"></i>
                  <span>Eligibility: All current CPVA student members</span>
                </div>
              </div>
            </div>
            <div className="text-center">
              <img
                src="https://readdy.ai/api/search-image?query=Group%20photo%20of%20diverse%20student%20council%20members%20in%20professional%20attire%2C%20standing%20together%20in%20modern%20university%20setting%2C%20leadership%20team%20portrait%2C%20confident%20and%20professional%20appearance%2C%20academic%20environment%20with%20medical%20equipment%20in%20background&width=500&height=400&seq=councilgroup1&orientation=landscape"
                alt="Student Council Team"
                className="w-full h-64 object-cover rounded-lg mb-4 object-top"
              />
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                Learn About Elections
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
